// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1qj10","visuallyhidden":"_3xQMS","hide-text":"_2JgpW","center":"_1vovg","noprint":"Rti91","root":"IKQCs","text":"p6LXb"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-blockquote/styles/sportsfeature.scss
 ** module id = 989
 ** module chunks = 2
 **/